//REACT
import { useContext, useEffect, useState } from 'react';
//YARN
import { toast } from 'react-toastify';
import { NavigateFunction, useNavigate } from 'react-router-dom';
//SERVICES
import { importCsvData, importParcelsResult, importParcelsStatus } from 'services/API/Cooperative';
import useAuth from 'providers/Auth/useAuth';
import { displayErrorMessage, formatFileSize } from 'utils/tools_functions';
import { ImportContext } from 'providers/ImportStatus/importStatus.providers';
//INTERFACE
import IFile from 'components/generics/Interface/Commons/IFile';
//THEMES
import Button from 'components/generics/Button';

const CooperativeCsvImport = () => {
  const [file, setFile] = useState<IFile | null>(null);
  const { user } = useAuth();
  const [cooperativeId, setCooperativeId] = useState<string | null>('');
  const navigate: NavigateFunction = useNavigate();
  const [locationRoute, setLocationRoute] = useState<string>('cooperative');
  const { setStatus, setJobId, result, setResult } = useContext(ImportContext);

  useEffect(() => {
    let coopId: string | null = '';
    if (localStorage.getItem('cooperative')) {
      coopId = localStorage.getItem('cooperative');
    } else if (user.cooperative?.id) {
      coopId = user.cooperative.id;
    }
    if (!coopId) {
      toast.info('Selectionnez une cooperative');
      navigate('/cooperative');
    } else {
      setCooperativeId(coopId);
    }
  }, [navigate, user]);

  useEffect(() => {
    setLocationRoute(window.location.pathname.split('/')[1]);
  }, []);

  useEffect(() => {
    if (result) {
      navigate(`/${locationRoute}/import/result`);
    }
  }, [result, navigate, locationRoute]);

  const importDataFromFile = () => {
    let formData = new FormData();
    if (!file) {
      return;
    }
    formData.append('file', file);
    importCsvData(formData, cooperativeId)
      .then((result) => {
        checkStatus(result.data.data.jobId);
        setJobId(result.data.data.jobId);
      })
      .catch((e) => {
        toast.error(displayErrorMessage('ERR_IMPORT_CSV'));
      });
  };

  const changeFileHandler = (importFile: FileList | null) => {
    if (!importFile) {
      return;
    }
    setFile(importFile[0]);
  };
  const checkStatus = (jobId: number) => {
    const interval = setInterval(() => {
      importParcelsStatus(jobId)
        .then((resp) => {
          setStatus(resp.data.message);
          if (resp.data.message !== 'En cours') {
            getJobResult(jobId);
            clearInterval(interval);
            if (resp.data.message === 'Fini sans erreur') {
              toast.success('Importation terminée sans erreur');
            } else {
              toast.error(displayErrorMessage('ERR_COMPLETE_IMPORT'));
            }
          }
        })
        .catch((err) => console.log(err));
    }, 1000);
  };

  const getJobResult = (jobId: number) => {
    importParcelsResult(jobId)
      .then((resp) => {
        setResult(resp.data);
      })
      .catch((err) => toast.error(displayErrorMessage('ERR_COMPLETE_IMPORT')));
  };

  return (
    <div className="section">
      <div className="main_container full-height">
        <h1 className="title_section">Import des données parcellaires CSV</h1>
        <div
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50%' }}
        >
          {file ? (
            <div className="information-file">
              <span style={{ color: '#707070', fontSize: 20 }}>
                Nom du fichier :{' '}
                <span style={{ fontWeight: 'bold', color: '#ffbe25', fontSize: 20 }}>
                  {file?.name}
                </span>
              </span>
              <span style={{ color: '#707070', fontSize: 20, marginTop: 20 }}>
                Taille du fichier :{' '}
                <span style={{ fontWeight: 'bold', color: '#ffbe25', fontSize: 20 }}>
                  {formatFileSize(file?.size)}
                </span>
              </span>

              <div
                className="button_upload"
                style={{ display: 'flex', flexDirection: 'row', marginTop: 50 }}
              >
                <div style={{ padding: '40px' }}>
                  <Button text="Importer les données" onClick={() => importDataFromFile()} />
                </div>
                <div style={{ padding: '40px' }}>
                  <Button
                    text="Importer un nouveau fichier"
                    onClick={() => setFile(null)}
                    backgroundColor="#e74c3c"
                  />
                </div>
              </div>
            </div>
          ) : (
            <>
              <input
                type="file"
                onChange={(e) => changeFileHandler(e.target.files)}
                accept="text/csv"
                id="file"
                className="input-file"
              />
              <label htmlFor="file" style={{ margin: 'auto' }}>
                Parcourir
              </label>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CooperativeCsvImport;
